<template>
  <div :class="$style['pt-report']" v-if="loadedPage">
    <div :class="$style['report-message']">
      <div class="report-message-number">
        <div class="report-number">编号：{{ data.codeNumber }}</div>
      </div>
    </div>
    <div class="title">委 托 检 验 检 测 协 议 书</div>
    <div :class="$style['report-message-content']">
      <user-message
        :partyAInformation="partyAInformation"
        :partyBInformation="partyBInformation"
      ></user-message>
      <single-sample-message
        :examination="examination"
        :data="examinationNew"
				:dataAll="data"
      ></single-sample-message>

      <entrust-message
        :data="entrustContentNew"
        :entrustContent="entrustContent"
        :examination="examination"
      ></entrust-message>
      <report-deliver :data="delivery" :cost="costShow"></report-deliver>
      <!-- <report-cost :data="cost"></report-cost> -->
      <report-sign></report-sign>
      <!-- <sample-message v-else :data="examination"></sample-message> -->
      <!-- <div v-if="examination.length > 5" class="common-page-before">
        <entrust-message
          :data="entrustContentNew"
          :entrustContent="entrustContent"
          :examination="examination"
        ></entrust-message>
        <report-deliver :data="delivery"></report-deliver>
        <report-cost :data="cost"></report-cost>
        <report-sign></report-sign>
      </div>
      <template v-else>
        <entrust-message
          :data="entrustContentNew"
          :entrustContent="entrustContent"
          :examination="examination"
        ></entrust-message>
        <div
          v-if="examination.length > 3 && examination.length <= 5"
          class="common-page-before"
        >
          <report-deliver :data="delivery"></report-deliver>
          <report-cost :data="cost"></report-cost>
          <report-sign></report-sign>
        </div>
        <template v-else>
          <report-deliver :data="delivery"> </report-deliver> -->
      <!-- <div v-if="examination.length <= 3" class="common-page-before"> -->
      <!-- <report-cost :data="cost"></report-cost> -->
      <!-- <report-sign></report-sign> -->
      <!-- </div>
          <template v-else> -->
      <!-- <report-cost :data="cost"></report-cost>
          <report-sign></report-sign> -->
      <!-- </template> -->
      <!-- </template> -->
      <!-- </template> -->
      <!-- <template v-else>
        <report-cost :data="cost"></report-cost>
        <report-sign></report-sign>
      </template> -->
    </div>
    <div :class="$style['contronct-notice']" class="common-page-after">
      <p>1. 本协议甲方“委托人”和乙方“受理人”签字后协议生效；</p>
      <p>2. 表中所列样品由甲方提供，甲方对样品资料的真实性负责；</p>
      <p>
        3.
        乙方按甲方提出的要求和检验检测项目进行检验检测，乙方对检验检测数据的真实性负责；
      </p>
      <p>
        4. 乙方对样品有疑问或无法按期完成检验检测工作时，乙方应及时通知甲方；
      </p>
      <p>
        5.
        甲方要求变更委托内容时，应在检验检测开始前通知乙方，由双方协商解决，必要时重签协议；
      </p>
      <p>6. 乙方负责按双方商定的方式发送检验检测报告和处理检后样品；</p>
      <p>7. 甲方在领取检验检测报告时，应出示本协议，以免发生误领或冒领。</p>
    </div>
    <!-- <sample-list
      :data="examination"
      v-if="examination && examination.length > 1"
    ></sample-list> -->
  </div>
</template>
<script>
import userMessage from "./user-message";
// import sampleMessage from "./sample-message";
import singleSampleMessage from "./single-sample-message";
import entrustMessage from "./entrust-message-new";
import reportDeliver from "./report-deliver";
// import reportCost from "./report-cost";
import reportSign from "./report-sign";
// import sampleList from "./sample-list";
export default {
  components: {
    userMessage,
    singleSampleMessage,
    // sampleMessage,
    entrustMessage,
    reportDeliver,
    // reportCost,
    reportSign,
    // sampleList,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    loaded: Boolean,
    loadErr: Boolean,
  },
  watch: {
    loaded(val) {
      if (val) {
        this.checkLoad();
      }
    },
    loadErr(val) {
      if (val) {
        this.checkLoad();
      }
    },
  },
  data() {
    return {
      loadedPage: false,
    };
  },
  methods: {
    checkLoad() {
      if (this.loaded) {
        this.loadedPage = true;
        confirm("加载完成");
      }
      if (this.loadedErr) {
        this.loadedPage = true;
        confirm("加载失败");
      }
    },
  },
  computed: {
    partyAInformation() {
      return this.data.partyAInformation || {};
    },
    costShow() {
      return this.data.costShow || {};
    },
    partyBInformation() {
      return this.data.partyBInformation || {};
    },
    examination () {
      return this.data.examination && this.data.examination.length
        ? this.data.examination
        : [{}];
    },
    examinationNew() {
      return this.data.examinationNew || {};
    },
    entrustContent() {
      return this.data.entrustContent;
    },
    entrustContentNew() {
      return this.data.entrustContentNew || {};
    },
    delivery() {
      return this.data.delivery || {};
    },
    cost() {
      return this.data.cost || {};
    },
  },
};
</script>
<style module lang="less">
.pt-report {
  font-size: 13px;
  :global {
    .title {
      font-size: 17px;
      font-weight: 600;
      padding: 0 0 10px;
    }

    .common-page-after {
      //强制在元素后分页
      page-break-after: always;
      position: relative;
    }
    .common-page-before {
      //强制在元素后分页
      page-break-before: always;
      position: relative;
      padding-top: 15px;
    }
  }
  table {
    width: 100%;
    page-break-inside: avoid;
    td {
      padding: 2px;
    }
    + table {
      border-top: none;
      // margin-top: -1px;
      tr {
        &:first-child {
          td {
            border-top: none;
          }
        }
      }
    }
  }
}
.report-message-content {
  overflow-x: hidden;
}
.report-message {
  :global {
    .report-message-number {
      display: flex;
      justify-content: flex-end;
    }
    .report-number {
      padding: 5px 20px;
      border: 1px solid #000;
      min-width: 200px;
      text-align: left;
    }
  }
}
.contronct-notice {
  padding-top: 5px;
  p {
    text-align: left;
    margin-block-start: 0.1em;
    margin-block-end: 0.1em;
		font-size: 11px;
    &:last-child {
      font-weight: 600;
    }
  }
}
</style>
<style type="text/css" lang="less" media="print">
@page {
  size: auto;
  margin: 30in; /* default for all pages */
}
#BrowserPrintDefaults {
  display: none;
}
.pagefooter {
  display: none;
}
@media print {
  .footer,
  #non-printable {
    display: none !important;
  }
  #printable {
    display: block;
  }
}
</style>
